import React from 'react';
import styled from '@emotion/styled';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import IconSvg from '../../common/IconSvg';

const CustomCard = styled(Card)`
  width: 178px;
  height: 244px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  box-shadow: 0px 1px 7px 0 ${({ theme }) => theme.colors.imageBoxShadow};

  &.highlighted {
    border-top: 4px solid ${({ theme }) => theme.colors.blueDark};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.blueMed};
    border-right-width: 1px !important;
    cursor: pointer;
  }
  & .ant-card-body {
    text-align: center;
    font-size: ${({ theme }) => theme.fontSize.medium};
    line-height: ${({ theme }) => theme.lineHeight.medium};
    color: ${({ theme }) => theme.colors.darkBlue};
    padding: 0;
  }
  & > .ant-card-cover > span {
    width: 100%;
    margin-top: ${props => 145 - props.coverheight}px;
  }
  & > .ant-card-head-wrapper > .ant-card-head-title {
    font-size: 16px;
    padding: 11px 0;
  }
`;

const LevelCard = props => (
  <CustomCard
    title={props.title}
    hoverable
    coverheight={props.coverheight}
    cover={<IconSvg type={props.type} height={props.coverheight} />}
    onClick={e => props.clickHandler(e)}
    className={props.highlighted ? 'highlighted' : undefined}
  >
    {props.description}
  </CustomCard>
);

LevelCard.propTypes = {
  coverheight: PropTypes.number,
  highlighted: PropTypes.bool,
  description: PropTypes.string,
  type: PropTypes.string,
  clickHandler: PropTypes.func,
};

export { LevelCard };
